const initState = () => ({
});

const audience = (state = initState(), action = {}) => {
    const { type } = action;

    switch (type) {
        default:
            return state;
    }
};

export default audience;
